import { SharedModule } from 'src/app/shared/shared.module';
import { NgModule } from '@angular/core';
import { FhirSummaryComponent } from './fhir-summary/fhir-summary.component';
import { MemberListService } from '../core/service/grid-data/grid-data-member.service';
import { FlagModule } from '../flag/flag.module';
import { CaseModule } from '../case/case.module';
import { MemberAssessmentModule } from '../shared/member-assessment/member-assessment.module';
import { ReferralModule } from '../referral/referral.module';
import { MessageModule } from '../message/message.module';

@NgModule({
  declarations: [
    FhirSummaryComponent
  ],
  imports: [
    SharedModule,
    FlagModule,
    CaseModule,
    MemberAssessmentModule,
    ReferralModule,
    MessageModule
  ],
  providers: [
    MemberListService
  ],
})
export class FhirModule { }
